// ⚠️ NUMERO DI TELEFONO: per cambiarlo modifica SOLO queste due righe
export const TELEFONO = "350 931 0909";
export const TELEFONO_HREF = "tel:+393509310909";

// Google Ads: conversione "click-to-call" — etichetta da variabile d'ambiente
export const ADS_CONVERSION_SEND_TO = process.env.REACT_APP_ADS_SEND_TO;
export function tracciaConversioneTelefono() {
  if (
    typeof window !== "undefined" &&
    typeof window.gtag === "function" &&
    ADS_CONVERSION_SEND_TO
  ) {
    window.gtag("event", "conversion", {
      send_to: ADS_CONVERSION_SEND_TO,
      value: 1.0,
      currency: "EUR",
    });
  }
}

// Snippet Google "phone_conversion_number": fa tracciare/sostituire il numero
// di telefono OVUNQUE compaia sul sito (numero derivato da TELEFONO, si
// aggiorna automaticamente se il numero cambia)
export function configuraNumeroConversione() {
  if (
    typeof window !== "undefined" &&
    typeof window.gtag === "function" &&
    ADS_CONVERSION_SEND_TO
  ) {
    window.gtag("config", ADS_CONVERSION_SEND_TO, {
      phone_conversion_number: TELEFONO.replace(/\s/g, ""),
    });
  }
}
export const WHATSAPP = "+39 345 678 9024";
export const EMAIL = "assistenza@sosriparazioni24.it";
export const INDIRIZZO = "Via Torino 24, 20123 Milano (MI)";

export const SERVIZI_SELECT = [
  "Pronto intervento idraulico",
  "Elettricista",
  "Fabbro e serrature",
  "Spurgo e autospurgo",
  "Caldaie e climatizzazione",
  "Altra emergenza",
];

export const CITTA = [
  { nome: "Milano", slug: "milano", tempo: "15-25 min", tecnici: 14, zona: "Città metropolitana di Milano" },
  { nome: "Monza", slug: "monza", tempo: "20-30 min", tecnici: 6, zona: "Monza e Brianza" },
  { nome: "Como", slug: "como", tempo: "25-35 min", tecnici: 5, zona: "Provincia di Como" },
  { nome: "Bergamo", slug: "bergamo", tempo: "20-30 min", tecnici: 7, zona: "Provincia di Bergamo" },
  { nome: "Brescia", slug: "brescia", tempo: "25-35 min", tecnici: 8, zona: "Provincia di Brescia" },
  { nome: "Pavia", slug: "pavia", tempo: "25-35 min", tecnici: 4, zona: "Provincia di Pavia" },
  { nome: "Lecco", slug: "lecco", tempo: "25-40 min", tecnici: 4, zona: "Provincia di Lecco" },
  { nome: "Varese", slug: "varese", tempo: "25-40 min", tecnici: 5, zona: "Provincia di Varese" },
  { nome: "Sondrio", slug: "sondrio", tempo: "30-45 min", tecnici: 3, zona: "Provincia di Sondrio" },
  { nome: "Cremona", slug: "cremona", tempo: "30-45 min", tecnici: 4, zona: "Provincia di Cremona" },
  { nome: "Lodi", slug: "lodi", tempo: "20-30 min", tecnici: 3, zona: "Provincia di Lodi" },
  { nome: "Mantova", slug: "mantova", tempo: "35-50 min", tecnici: 3, zona: "Provincia di Mantova" },
];

export const FAQ = [
  {
    domanda: "Quanto tempo impiegate ad arrivare?",
    risposta: "I nostri tecnici sono già dislocati in ogni provincia lombarda, quindi riusciamo a intervenire molto rapidamente sia nei grandi centri sia nei comuni più piccoli. Alla chiamata ti comunichiamo subito una stima precisa dell'orario di arrivo.",
  },
  {
    domanda: "Il servizio è davvero attivo 24 ore su 24?",
    risposta: "Sì, siamo operativi 24 ore su 24, 7 giorni su 7, compresi festivi, weekend e notti. La nostra centrale operativa risponde sempre con un operatore reale, mai con un risponditore automatico.",
  },
  {
    domanda: "Fate anche lavori programmati o solo urgenze?",
    risposta: "Oltre al pronto intervento H24 eseguiamo lavori su appuntamento: manutenzioni, sostituzioni e piccoli adeguamenti di impianti idraulici ed elettrici. Scrivici dal modulo o in chat e fissiamo insieme data e ora.",
  },
  {
    domanda: "Intervenite anche per condomini e aziende?",
    risposta: "Sì, gestiamo interventi per privati, condomini, uffici, negozi e strutture ricettive. Per amministratori di condominio e aziende offriamo anche convenzioni dedicate con priorità di intervento.",
  },
  {
    domanda: "I tecnici sono qualificati e assicurati?",
    risposta: "Tutti i nostri tecnici sono certificati, con esperienza pluriennale e coperti da assicurazione RC professionale. Utilizziamo solo ricambi originali o di qualità equivalente, con garanzia sul lavoro eseguito.",
  },
  {
    domanda: "Posso pagare con carta o bancomat?",
    risposta: "Sì, accettiamo contanti, carte di credito, bancomat e bonifico. Per gli interventi aziendali e condominiali è disponibile anche la fatturazione elettronica.",
  },
];
